import { CheckCircleRounded, ErrorRounded, InfoRounded, WarningRounded } from '@mui/icons-material';
import Portal from '@mui/material/Portal';

import { snackbarClasses } from './classes';
import { SnackbarRoot, type SnackbarRootProps } from './styles';

// ----------------------------------------------------------------------

export function Snackbar(props: SnackbarRootProps) {
  return (
    <Portal>
      <SnackbarRoot
        expand
        closeButton
        gap={12}
        offset={16}
        visibleToasts={4}
        position="top-right"
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: snackbarClasses.toast,
            icon: snackbarClasses.icon,
            loader: snackbarClasses.loader,
            loading: snackbarClasses.loading,
            /***/
            content: snackbarClasses.content,
            title: snackbarClasses.title,
            description: snackbarClasses.description,
            /***/
            closeButton: snackbarClasses.closeButton,
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            /***/
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning
          }
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: <InfoRounded className={snackbarClasses.iconSvg} />,
          success: <CheckCircleRounded className={snackbarClasses.iconSvg} />,
          warning: <WarningRounded className={snackbarClasses.iconSvg} />,
          error: <ErrorRounded className={snackbarClasses.iconSvg} />
        }}
        {...props}
      />
    </Portal>
  );
}
